const STORAGE_PREFIX = 'enr-3102-hourly-post-failure:';

export function buildHourlyPostFailureStorageKey(args: {
  sessionId: string;
  fromDate: string;
  toDate: string;
}): string {
  return `${STORAGE_PREFIX}${args.sessionId}|${args.fromDate}|${args.toDate}`;
}

export function readHourlyPostFailures(
  storageKey: string,
): Record<string, string> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(storageKey);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    const out: Record<string, string> = {};
    for (const [studentId, reason] of Object.entries(
      parsed as Record<string, unknown>,
    )) {
      if (typeof reason === 'string' && reason.trim()) {
        out[studentId] = reason.trim();
      }
    }
    return out;
  } catch {
    return {};
  }
}

export function writeHourlyPostFailures(
  storageKey: string,
  failures: Record<string, string>,
): void {
  if (typeof window === 'undefined') return;
  try {
    if (Object.keys(failures).length === 0) {
      window.sessionStorage.removeItem(storageKey);
      return;
    }
    window.sessionStorage.setItem(storageKey, JSON.stringify(failures));
  } catch {
    // Ignore quota / private-mode failures; badges still work in-session.
  }
}

export function mergeHourlyPostFailures(
  existing: Record<string, string>,
  next: Map<string, string>,
): Record<string, string> {
  const merged = { ...existing };
  for (const [studentId, reason] of next.entries()) {
    if (reason.trim()) merged[studentId] = reason.trim();
  }
  return merged;
}
